module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Communication/Address-card-0bd08d03ff78691f9d22bba6eeabe0bb.svg";